import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

import { products } from '../products';
import { BasketService } from '../basket.service';

import Drift from 'drift-zoom';

export interface DialogData {
  product: string;
  image: string;
}

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.css']
})
export class ProductDetailsComponent implements OnInit {
  product;
  showCheckout=false;
  
  constructor(
    private route: ActivatedRoute,
    private basketService: BasketService,
    public dialog: MatDialog
  ) { }

  addToBasket(product) {
    this.basketService.addToBasket(product);

    const dialogRef = this.dialog.open(DialogBuySuccess, {
      width: '250px',
      data: { product: this.product.name }
    });

    this.showCheckout=true;
  }


  showImage(img) {
    
    const dialogRef = this.dialog.open(DialogBuySuccess, {
      width: '360px',
      data: { image: img }
    });
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.product = products[+params.get('productId')]
      });
  }



}

@Component({
  selector: 'dialog-buy-success',
  templateUrl: 'dialog-buy-success.html',
  styleUrls: ['./dialog-buy-success.css']
})
export class DialogBuySuccess {

  constructor(
    public dialogRef: MatDialogRef<DialogBuySuccess>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}